// import React from "react";
// import { useState, useEffect } from "react";
// // import { useAuth } from "./Utility/AuthProvider";
// import { AuthProvider } from "./Utility/AuthProvider";
// import { UnitProvider } from "./Contexts/UnitContext";
// import APICall from "./Utility/APICall";
// import { paths } from "./Utility/Constants";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import Layout from "./components/Layout";
// import LoginForm from "./LoginForm";
// import OTP from "./OTP";
// import AddInfo from "./AddInfo";
// import Dashboard from "./Dashboard";
// import { useAuth } from "./Utility/AuthProvider";
// import ViewAll from "./components/UpcomingRent/ViewAll";
// import MyProperties from "./components/Properties/MyProperties";
// import Reports from "./components/Reports/Reports";
// import Payments from "./components/PaymentsTab/Payments";
// import WhatsAppComponent from "./components/Reports/components/WhatsappComponent";
// import Units from "./components/Properties/Units";
// import Buildings from "./components/Properties/Buildings";
// import AddNewBuilding from "./components/Properties/AddNewBuilding";
// import AddNewUnit from "./components/Properties/AddNewUnit";
// import UnitDetails from "./components/Properties/UnitDetails";
// import BuildingDetails from "./components/Properties/BuildingDetails";
// import TenantsList from "./components/Properties/TenantsList";
// import AddNewTenant from "./components/Tenants/AddNewTenant";
// import Agreements from "./components/Agreements/Agreements";
// import AddAgreement from "./components/Agreements/AddAgreement";
// import AgreementOverview from "./components/Agreements/AgreementOverview";
// import { AgreementProvider } from "./components/Agreements/AgreementContext";
// import PrivacyPolicy from "./components/PrivacyPolicy";
// import RentCollection from "./pages/RentCollection";
// import {
//   TenantContext,
//   TenantProvider,
// } from "./components/Tenants/TenantContext";
// import { UnitDetailsProvider } from "./components/Properties/UnitDetailsContext";
// import ModifyAgreement from "./components/Agreements/ModifyAgreement";
// import CollectionsBuildingWise from "./pages/CollectionsBuildingWise";
// import { BuildingProvider } from "./Contexts/BuildingContext";
// import { UnitContext } from "./Contexts/UnitContext";

// function App() {
//   const { jwt } = useAuth();
//   const [buildingData, setBuildingData] = useState([]);
//   const [unitData, setUnitData] = useState([]);
//   const [agreementData, setAgreementData] = useState([]);
//   const [tenantData, setTenantData] = useState([]);
//   const [loading, setLoading] = useState(false);

//   // useEffect(() => {
//   //   const fetchData = async () => {
//   //     try {
//   //       setLoading(true);
//   //       const buildingResponse = await APICall(
//   //         "GET",
//   //         paths.building.fetch,
//   //         undefined,
//   //         undefined,
//   //         jwt
//   //       );
//   //       setBuildingData(buildingResponse.response);
//   //       const unitResponse = await APICall(
//   //         "GET",
//   //         paths.unit.fetch,
//   //         undefined,
//   //         undefined,
//   //         jwt
//   //       );
//   //       setUnitData(unitResponse.response);
//   //       const tenantResponse = await APICall(
//   //         "GET",
//   //         paths.tenant.fetch,
//   //         undefined,
//   //         undefined,
//   //         jwt
//   //       );
//   //       setTenantData(tenantResponse.response);
//   //       const agreementResponse = await APICall(
//   //         "GET",
//   //         paths.agreement.fetch,
//   //         undefined,
//   //         undefined,
//   //         jwt
//   //       );
//   //       setAgreementData(agreementResponse.response);
//   //     } catch (error) {
//   //       console.error("Error fetching data:", error);
//   //     } finally {
//   //       setLoading(false);
//   //     }
//   //   };

//   //   fetchData();
//   // }, [jwt]);

//   // console.log("APP.JS DATA for tenant-", buildingData);
//   // console.log("APP.JS DATA for agreement -", unitData);

//   return (
//     // <div className="App">
//     //   <UnitDetailsProvider>
//     //     <AgreementProvider>
//     //       <BuildingProvider>
//     //         <UnitContext>
//     //           <UnitDetailsProvider>
//     //             <TenantProvider>
//     //               <Router>
//     //                 <Routes>
//     //                   {jwt !== "" ? (
//     //                     <>
//     //                       {/* Layout with Sidebar and Navbar */}
//     //                       <Route path="/" element={<Layout />}>
//     //                         <Route index element={<Dashboard />} />
//     //                         <Route
//     //                           path="CollectionsBuildingWise"
//     //                           element={<CollectionsBuildingWise />}
//     //                         />

//     //                         <Route path="ViewAll" element={<ViewAll />} />
//     //                         <Route path="Payments" element={<Payments />} />
//     //                         <Route
//     //                           path="MyProperties"
//     //                           element={<MyProperties />}
//     //                         />
//     //                         <Route
//     //                           path="Reports"
//     //                           element={
//     //                             <Reports
//     //                             // agreement={agreementData}
//     //                             // tenant={tenantData}
//     //                             // building={buildingData}
//     //                             // unit={unitData}
//     //                             />
//     //                           }
//     //                         />
//     //                         <Route
//     //                           path="Units"
//     //                           element={
//     //                             <Units
//     //                             // building={buildingData}
//     //                             // unit={unitData}
//     //                             // loading={loading}
//     //                             />
//     //                           }
//     //                         />
//     //                         <Route path="Buildings" element={<Buildings />} />
//     //                         <Route
//     //                           path="AddNewBuilding"
//     //                           element={<AddNewBuilding />}
//     //                         />
//     //                         <Route
//     //                           path="/AddNewUnit"
//     //                           element={<AddNewUnit />}
//     //                         />
//     //                         <Route
//     //                           path="AddNewTenant"
//     //                           element={<AddNewTenant />}
//     //                         />
//     //                         <Route
//     //                           path="/MyProperties"
//     //                           element={<MyProperties />}
//     //                         />
//     //                         <Route
//     //                           path="MyProperties/:unitId"
//     //                           element={<UnitDetails />}
//     //                         />
//     //                         <Route
//     //                           path="/MyProperties/:unitId/AddAgreement"
//     //                           element={<AddAgreement />}
//     //                         />
//     //                         <Route
//     //                           path="/MyProperties/:unitId/ModifyAgreement"
//     //                           element={<ModifyAgreement />}
//     //                         />
//     //                         <Route
//     //                           path="/MyProperties/:unitId/AddAgreement/AddNewTenant"
//     //                           element={<AddNewTenant />}
//     //                         />
//     //                         <Route
//     //                           path="/AgreementOverview"
//     //                           element={<AgreementOverview />}
//     //                         />

//     //                         <Route
//     //                           path="MyProperties/BuildingDetails/:buildingId"
//     //                           element={<BuildingDetails />}
//     //                         />
//     //                         <Route path="Agreements" element={<Agreements />} />
//     //                         <Route
//     //                           path="MyProperties/TenantsList"
//     //                           element={<TenantsList />}
//     //                         />
//     //                         <Route
//     //                           path="WhatsAppComponent"
//     //                           element={<WhatsAppComponent />}
//     //                         />
//     //                       </Route>

//     //                       {/* Layout without Sidebar and Navbar */}
//     //                       <Route path="/AddInfo" element={<AddInfo />} />
//     //                       <Route
//     //                         path="/RentCollection"
//     //                         element={<RentCollection />}
//     //                       />
//     //                     </>
//     //                   ) : (
//     //                     <>
//     //                       <Route path="/" element={<LoginForm />} />
//     //                       <Route path="/OTP" element={<OTP />} />
//     //                       <Route path="/AddInfo" element={<AddInfo />} />
//     //                     </>
//     //                   )}
//     //                   <Route
//     //                     path="/privacy-policy"
//     //                     element={<PrivacyPolicy />}
//     //                   />
//     //                 </Routes>
//     //               </Router>
//     //             </TenantProvider>
//     //           </UnitDetailsProvider>
//     //         </UnitContext>
//     //       </BuildingProvider>
//     //     </AgreementProvider>
//     //   </UnitDetailsProvider>
//     // </div>
//     <div className="App">
//       {/* AuthProvider should typically be the outermost as JWT is often needed everywhere */}
//       <AuthProvider>
//         {/*
//           Nested providers. The order generally matters for dependencies.
//           If UnitContext uses BuildingContext, BuildingProvider should be outside UnitContext.
//           If UnitDetailsProvider uses UnitContext, UnitContext should be outside UnitDetailsProvider.
//         */}
//         <TenantProvider>
//           <BuildingProvider>
//             <UnitProvider>
//               {/* Provides all units data, including counts */}
//               <UnitDetailsProvider>
//                 {/* Provides single unit details */}
//                 <AgreementProvider>
//                   {" "}
//                   {/* Provides agreement data */}
//                   <Router>
//                     <Routes>
//                       {jwt !== "" ? (
//                         <>
//                           {/* Layout with Sidebar and Navbar */}
//                           <Route path="/" element={<Layout />}>
//                             <Route index element={<Dashboard />} />
//                             <Route
//                               path="CollectionsBuildingWise"
//                               element={<CollectionsBuildingWise />}
//                             />
//                             <Route path="ViewAll" element={<ViewAll />} />
//                             <Route path="Payments" element={<Payments />} />
//                             <Route
//                               path="MyProperties"
//                               element={<MyProperties />}
//                             />
//                             <Route
//                               path="Reports"
//                               element={
//                                 <Reports
//                                 // Make sure these props are actually needed or remove them.
//                                 // It's better to consume contexts directly in Reports.
//                                 // agreement={agreementData}
//                                 // tenant={tenantData}
//                                 // building={buildingData}
//                                 // unit={unitData}
//                                 />
//                               }
//                             />
//                             <Route
//                               path="Units"
//                               element={
//                                 <Units
//                                 // Same here, consume contexts directly in Units component
//                                 // building={buildingData}
//                                 // unit={unitData}
//                                 // loading={loading}
//                                 />
//                               }
//                             />
//                             <Route path="Buildings" element={<Buildings />} />
//                             <Route
//                               path="AddNewBuilding"
//                               element={<AddNewBuilding />}
//                             />
//                             <Route
//                               path="/AddNewUnit"
//                               element={<AddNewUnit />}
//                             />
//                             <Route
//                               path="AddNewTenant"
//                               element={<AddNewTenant />}
//                             />
//                             {/* <Route path="/MyProperties" element={<MyProperties />} /> // Duplicate route for MyProperties */}
//                             <Route
//                               path="MyProperties/:unitId"
//                               element={<UnitDetails />}
//                             />
//                             <Route
//                               path="/MyProperties/:unitId/AddAgreement"
//                               element={<AddAgreement />}
//                             />
//                             <Route
//                               path="/MyProperties/:unitId/ModifyAgreement"
//                               element={<ModifyAgreement />}
//                             />
//                             <Route
//                               path="/MyProperties/:unitId/AddAgreement/AddNewTenant"
//                               element={<AddNewTenant />}
//                             />
//                             <Route
//                               path="/AgreementOverview"
//                               element={<AgreementOverview />}
//                             />
//                             <Route
//                               path="MyProperties/BuildingDetails/:buildingId"
//                               element={<BuildingDetails />}
//                             />
//                             <Route path="Agreements" element={<Agreements />} />
//                             <Route
//                               path="MyProperties/TenantsList"
//                               element={<TenantsList />}
//                             />
//                             <Route
//                               path="WhatsAppComponent"
//                               element={<WhatsAppComponent />}
//                             />
//                           </Route>

//                           {/* Layout without Sidebar and Navbar */}
//                           <Route path="/AddInfo" element={<AddInfo />} />
//                           <Route
//                             path="/RentCollection"
//                             element={<RentCollection />}
//                           />
//                         </>
//                       ) : (
//                         <>
//                           <Route path="/" element={<LoginForm />} />
//                           <Route path="/OTP" element={<OTP />} />
//                           <Route path="/AddInfo" element={<AddInfo />} />
//                         </>
//                       )}
//                       <Route
//                         path="/privacy-policy"
//                         element={<PrivacyPolicy />}
//                       />
//                     </Routes>
//                   </Router>
//                 </AgreementProvider>
//               </UnitDetailsProvider>
//             </UnitProvider>
//           </BuildingProvider>
//         </TenantProvider>
//       </AuthProvider>
//     </div>
//   );
// }

// export default App;

// App.js
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Outlet,
  useLocation,
} from "react-router-dom";
import { AuthProvider, useAuth } from "./Utility/AuthProvider";

// Your other context providers
import { UnitProvider } from "./Contexts/UnitContext";
import { TenantProvider } from "./components/Tenants/TenantContext";
import { UnitDetailsProvider } from "./components/Properties/UnitDetailsContext";
import { AgreementProvider } from "./components/Agreements/AgreementContext";
import { BuildingProvider } from "./Contexts/BuildingContext";

// Your Page/Component Imports
import Layout from "./components/Layout"; // Main application layout with sidebar/navbar
import AuthPage from "./AuthPage";
// import LoginForm from "./LoginForm";
// import OTP from "./OTP";
import AddInfo from "./AddInfo";
import Dashboard from "./Dashboard";
import ViewAll from "./components/UpcomingRent/ViewAll";
import MyProperties from "./components/Properties/MyProperties";
import Reports from "./components/Reports/Reports";
import Payments from "./components/PaymentsTab/Payments";
import WhatsAppComponent from "./components/Reports/components/WhatsappComponent";
import Units from "./components/Properties/Units";
import Buildings from "./components/Properties/Buildings";
import AddNewBuilding from "./components/Properties/AddNewBuilding";
import AddNewUnit from "./components/Properties/AddNewUnit";
import UnitDetails from "./components/Properties/UnitDetails";
import BuildingDetails from "./components/Properties/BuildingDetails";
import TenantsList from "./components/Properties/TenantsList";
import AddNewTenant from "./components/Tenants/AddNewTenant";
import Agreements from "./components/Agreements/Agreements";
import AddAgreement from "./components/Agreements/AddAgreement";
import AgreementOverview from "./components/Agreements/AgreementOverview";
import PrivacyPolicy from "./components/PrivacyPolicy";
import RentCollection from "./pages/RentCollection";
import ModifyAgreement from "./components/Agreements/ModifyAgreement";
import CollectionsBuildingWise from "./pages/CollectionsBuildingWise";
import LoadingOverlay from "./components/LoadingOverlay";
import AddMoreTenant from "./components/Tenants/AddMoreTenant";

// profile related imports
import AccountPage from "./pages/profile/AccountsPage";
import NotificationsPage from "./pages/profile/NotificationsPage";
import ProfilePaymentsPage from "./pages/profile/ProfilePaymentsPage";
import GeneralSettingsPage from "./pages/profile/GeneralSettingsPage";
import HelpAndSupportPage from "./pages/profile/HelpAndSupportPage";
import { SettingsProvider } from "./Contexts/SettingsContext";
import ProfileLayout from "./pages/profile/ProfileLayout";
import TermsConditionsPage from "./pages/profile/TermsConditionsPage";
import TroubleshootPage from "./Utility/TroubleshootPage";

import ReportsDataProvider from "./Contexts/ReportsContext";
import { PaymentsContext, PaymentsProvider } from "./Contexts/PaymentsContext";

// Handles redirecting authenticated users away from auth page
const AuthRedirect = () => {
  const { jwt } = useAuth();

  if (jwt) {
    return <Navigate to="/dashboard" replace />;
  }

  return <AuthPage />;
};

// --- ProtectedRoute Component ---
const ProtectedRoute = ({ children }) => {
  const { jwt, user, isLoadingSession } = useAuth(); // Get isLoadingSession
  const location = useLocation();

  if (isLoadingSession) {
    // While checking for JWT existence on initial load
    // return <div>Loading session...</div>;
    return <LoadingOverlay />;
  }

  if (!jwt) {
    // User is not authenticated
    // Redirect to login page, preserving the current location
    // This allows redirection back after login
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  // User is authenticated (and profile is complete or they are on /add-info)
  return children ? children : <Outlet />; // Render children or Outlet for nested routes
};

// --- AppRoutes Component ---
const AppRoutes = () => {
  const { jwt } = useAuth(); // Get auth status
  return (
    <Routes>
      {/* --- Public Routes --- */}
      {/* If authenticated, redirect from login/otp to dashboard */}

      <Route path="/auth" element={<AuthRedirect />} />
      {/* Legacy Route Redirects - redirect old login/otp routes to unified auth */}
      <Route path="/" element={<Navigate to="/auth" replace />} />
      <Route path="/otp" element={<Navigate to="/auth" replace />} />

      {/* <Route
        path="/" // Login page
        element={jwt ? <Navigate to="/dashboard" replace /> : <LoginForm />}
      />
      <Route
        path="/otp" // OTP page
        element={jwt ? <Navigate to="/dashboard" replace /> : <OTP />}
      /> */}
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />

      {/* --- Protected Routes --- */}
      {/* AddInfo page, protected but might be accessed before full dashboard access */}
      <Route
        path="/add-info"
        element={
          <ProtectedRoute>
            <AddInfo />
          </ProtectedRoute>
        }
      />

      {/* Main application routes under /dashboard, using Layout */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            {/* Ensures user is authed & profile complete before accessing Layout */}
            <Layout />
          </ProtectedRoute>
        }
      >
        {/* Index route for /dashboard */}
        <Route index element={<Dashboard />} />
        {/* profile related routes */}
        <Route path="/dashboard/profile" element={<ProfileLayout />} />
        <Route path="/dashboard/profile/account" element={<AccountPage />} />
        <Route
          path="/dashboard/profile/notifications"
          element={<NotificationsPage />}
        />
        <Route
          path="/dashboard/profile/payments"
          element={<ProfilePaymentsPage />}
        />
        <Route
          path="/dashboard/profile/settings"
          element={<GeneralSettingsPage />}
        />
        <Route
          path="/dashboard/profile/help-support"
          element={<HelpAndSupportPage />}
        />
        {/* <Route path="profile/privacy-policy" element={<PrivacyPolicyPage />} /> */}
        <Route
          path="profile/terms-conditions"
          element={<TermsConditionsPage />}
        />
        <Route path="troubleshoot" element={<TroubleshootPage />} />
        {/* Collections */}
        <Route
          path="collections-building-wise"
          element={<CollectionsBuildingWise />}
        />
        <Route path="view-all" element={<ViewAll />} />{" "}
        {/* Assuming this is upcoming rent view all */}
        {/* Payments */}
        <Route path="payments" element={<Payments />} />
        {/* Properties Management */}
        <Route path="/dashboard/my-properties" element={<MyProperties />} />
        <Route
          path="/dashboard/my-properties/:unitId"
          element={<UnitDetails />}
        />
        <Route
          path="my-properties/building-details/:buildingId"
          element={<BuildingDetails />}
        />
        {/* <Route path="my-properties/tenants-list" element={<TenantsList />} /> */}
        <Route path="tenants-list" element={<TenantsList />} />
        {/* Adding New Entities */}
        <Route path="add-new-building" element={<AddNewBuilding />} />
        <Route path="add-new-unit" element={<AddNewUnit />} />{" "}
        {/* Ensure this path is unique or nested if needed */}
        {/* <Route path="add-new-tenant" element={<AddNewTenant />} /> */}
        {/* Agreements */}
        <Route path="agreements" element={<Agreements />} />
        <Route
          path="/dashboard/my-properties/:unitId/add-agreement"
          element={<AddAgreement />}
        />
        <Route
          path="/dashboard/my-properties/:unitId/add-agreement/add-new-tenant"
          element={<AddNewTenant />}
        />
        <Route
          path="/dashboard/my-properties/:unitId/add-agreement/add-more-tenant"
          element={<AddMoreTenant />}
        />
        {/* Nested tenant add */}
        <Route
          path="my-properties/:unitId/modify-agreement"
          element={<ModifyAgreement />}
        />
        {/*--------- new routes ------ */}
        <Route
          path="agreements/:agreementId/modify/review-tenants"
          element={<AddMoreTenant />}
        />
        <Route
          path="agreements/:agreementId/modify/add-tenant"
          element={<AddNewTenant />}
        />
        <Route
          path="agreements/:agreementId/modify/overview"
          element={<AgreementOverview />}
        />
        {/* ----------------- */}
        <Route
          path="/dashboard/my-properties/:unitId/add-agreement/agreement-overview"
          element={<AgreementOverview />}
        />
        {/* Or perhaps /agreements/:agreementId/overview */}
        {/* Reports & Other */}
        <Route path="reports" element={<Reports />} />
        <Route path="units" element={<Units />} /> {/* List of all units? */}
        <Route path="buildings" element={<Buildings />} />
        {/* List of all buildings? */}
        <Route path="whatsapp-component" element={<WhatsAppComponent />} />
        {/* Add any other routes that should be within the main Layout here */}
      </Route>

      {/* Other top-level protected routes (if any, not using the main Layout) */}
      <Route
        path="/rent-collection"
        element={
          <ProtectedRoute>
            <RentCollection />
          </ProtectedRoute>
        }
      />

      {/* Fallback / Not Found Route - Redirects to dashboard if logged in, else to login */}
      <Route
        path="*"
        element={<Navigate to={jwt ? "/dashboard" : "/auth"} replace />}
      />
    </Routes>
  );
};

// --- Main App Component ---
function App() {
  return (
    <div className="App">
      <AuthProvider>
        <SettingsProvider>
          <ReportsDataProvider>
            {/* Ensure correct nesting order if providers depend on each other.
            For example, if TenantProvider needs BuildingProvider, BuildingProvider should be outer.
            If they are independent, the order is less critical but keep related ones together. */}
            <PaymentsProvider>
              <TenantProvider>
                <BuildingProvider>
                  <UnitProvider>
                    <UnitDetailsProvider>
                      <AgreementProvider>
                        <Router>
                          <AppRoutes />
                        </Router>
                      </AgreementProvider>
                    </UnitDetailsProvider>
                  </UnitProvider>
                </BuildingProvider>
              </TenantProvider>
            </PaymentsProvider>
          </ReportsDataProvider>
        </SettingsProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
